// src/pages/MerchPage.js — Page merch personnalisé Oni
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import "./MerchPage.css";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

const PRODUCT_TYPES = [
  {
    id:    "tshirt",
    label: "T-SHIRT",
    icon:  "👕",
    desc:  "Gildan 5000 Heavy Cotton · Impression recto",
    price: "29.99€",
    sizes: "S — 2XL · Noir",
  },
  // Mug et Poster a venir — necessitent blueprint_id/provider/variants Printify
];

export default function MerchPage() {
  const { user, profile } = useAuth();
  const demon    = profile?.demon;
  const oni      = demon?.oni;

  const [productType, setProductType] = useState("tshirt");
  const [playerName,  setPlayerName]  = useState(profile?.displayName || "");
  const [loading,     setLoading]     = useState(false);
  const [result,      setResult]      = useState(null);
  const [error,       setError]       = useState(null);

  const createProduct = async () => {
    if (!oni || !playerName.trim()) return;
    setLoading(true); setError(null); setResult(null);

    try {
      const res = await fetch(`${API}/printify/oni-product`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({
          oniId:       oni.id,
          oniName:     oni.name,
          playerName:  playerName.trim(),
          productType,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Erreur serveur");
      setResult(data);
    } catch(e) {
      setError(e.message);
    }
    setLoading(false);
  };

  if (!user) return (
    <div className="merch-page section" style={{paddingTop:"8rem", textAlign:"center"}}>
      <span className="section-eyebrow">商品 · Boutique</span>
      <h2 className="section-title">Connexion requise</h2>
      <div className="divider divider-center"/>
      <Link to="/auth" className="btn btn-primary" style={{marginTop:"1.5rem"}}>ENTRER →</Link>
    </div>
  );

  if (!demon) return (
    <div className="merch-page section" style={{paddingTop:"8rem", textAlign:"center"}}>
      <span className="section-eyebrow">商品 · Boutique</span>
      <h2 className="section-title">Pas encore de démon</h2>
      <div className="divider divider-center"/>
      <Link to="/awaken" className="btn btn-primary" style={{marginTop:"1.5rem"}}>RÉVEILLER MON DÉMON →</Link>
    </div>
  );

  const selectedProduct = PRODUCT_TYPES.find(p => p.id === productType);

  return (
    <div className="merch-page">
      <div className="section" style={{paddingTop:"7rem"}}>

        <div className="merch-header">
          <div>
            <span className="section-eyebrow">商品 · Boutique</span>
            <h1 className="section-title">Ton Oni<br/>sur du vrai</h1>
            <div className="divider"/>
            <p className="section-sub">
              Commande un produit avec ton démon. Fabriqué à la demande, livré chez toi.
            </p>
          </div>
          {oni?.image && (
            <div className="merch-oni-preview">
              <img src={`${oni.image}?v=2`} alt={oni.name} className="merch-oni-img"/>
              <div className="merch-oni-label">
                <p className="merch-oni-jp">{oni.jp}</p>
                <p className="merch-oni-name">{oni.name}</p>
              </div>
            </div>
          )}
        </div>

        {/* Résultat */}
        {result && (
          <div className="merch-result">
            <div className="merch-result-header">
              <span>✓</span>
              <div>
                <p className="merch-result-title">Produit créé — {result.title}</p>
                <p className="merch-result-sub">Ton produit est prêt à la commande.</p>
              </div>
            </div>
            {result.mockupUrl && (
              <div className="merch-mockup-wrap">
                <img src={result.mockupUrl} alt="Mockup" className="merch-mockup"/>
              </div>
            )}
            <a
              href={result.checkoutUrl}
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary merch-checkout-btn"
            >
              COMMANDER → {selectedProduct?.price}
            </a>
            <button className="btn btn-ghost btn-sm" onClick={() => setResult(null)}>
              RECOMMENCER ↺
            </button>
          </div>
        )}

        {!result && (
          <div className="merch-configurator">

            {/* Choix du produit */}
            <div className="merch-section">
              <p className="merch-section-title">1. CHOISIR LE PRODUIT</p>
              <div className="merch-product-grid">
                {PRODUCT_TYPES.map(p => (
                  <button
                    key={p.id}
                    className={`merch-product-card${productType === p.id ? " selected" : ""}`}
                    onClick={() => setProductType(p.id)}
                  >
                    <span className="merch-product-icon">{p.icon}</span>
                    <p className="merch-product-label">{p.label}</p>
                    <p className="merch-product-desc">{p.desc}</p>
                    <p className="merch-product-sizes">{p.sizes}</p>
                    <p className="merch-product-price">{p.price}</p>
                  </button>
                ))}
              </div>
            </div>

            {/* Nom du joueur */}
            <div className="merch-section">
              <p className="merch-section-title">2. TON NOM SUR LE PRODUIT</p>
              <p className="merch-section-sub">Ce nom apparaîtra sur le produit avec ton Oni.</p>
              <input
                type="text"
                value={playerName}
                onChange={e => setPlayerName(e.target.value)}
                placeholder="Ton pseudo ou prénom..."
                className="merch-name-input"
                maxLength={20}
              />
              <p className="merch-char-count">{playerName.length}/20</p>
            </div>

            {/* Aperçu */}
            <div className="merch-section merch-preview">
              <p className="merch-section-title">3. APERÇU</p>
              <div className="merch-preview-card">
                {oni?.image ? (
                  <img src={`${oni.image}?v=2`} alt={oni.name} className="merch-preview-oni"/>
                ) : (
                  <span className="merch-preview-emoji">{oni?.emoji}</span>
                )}
                <div className="merch-preview-info">
                  <p className="merch-preview-product">{selectedProduct?.icon} {selectedProduct?.label}</p>
                  <p className="merch-preview-oni-name">{oni.jp} · {oni.name}</p>
                  {playerName && <p className="merch-preview-player">{playerName}</p>}
                </div>
              </div>
              <p className="merch-disclaimer">
                ⚠️ Les images des Oni sont dessinées à la main par Nayth. La résolution finale dépend de la taille des fichiers originaux.
              </p>
            </div>

            {/* Error */}
            {error && (
              <div className="merch-error">
                <span>⚠️</span>
                <p>{error}</p>
              </div>
            )}

            {/* CTA */}
            <button
              className="btn btn-primary merch-cta"
              onClick={createProduct}
              disabled={loading || !playerName.trim()}
            >
              {loading ? (
                <><span className="spinner"/>CRÉATION DU PRODUIT...</>
              ) : (
                `CRÉER MON PRODUIT ${oni?.emoji} →`
              )}
            </button>
            <p className="merch-cta-sub">
              Le produit sera créé dans ta boutique Printify. Tu seras redirigé vers le checkout.
            </p>
          </div>
        )}

        {/* Info livraison */}
        <div className="merch-info-grid">
          <div className="merch-info-card">
            <span>🖨️</span>
            <p>Impression à la demande</p>
            <small>Fabriqué uniquement à la commande, pas de stock.</small>
          </div>
          <div className="merch-info-card">
            <span>🚚</span>
            <p>Livraison mondiale</p>
            <small>Expédié depuis l'imprimeur le plus proche.</small>
          </div>
          <div className="merch-info-card">
            <span>🎨</span>
            <p>Illustrations originales</p>
            <small>Chaque Oni dessiné à la main par Nayth.</small>
          </div>
          <div className="merch-info-card">
            <span>🔒</span>
            <p>Paiement sécurisé</p>
            <small>Checkout Printify — Stripe intégré.</small>
          </div>
        </div>
      </div>
    </div>
  );
}
